import { PERMISSIONS } from 'app/constants/UserConstants';

// Determines whether a user is allowed to add free text or not.
export function allowFreeText(user) {
  return !!(user && user.get('permissions')) && user.get('permissions').indexOf(PERMISSIONS.UGC_FREE_TEXT) > -1;
}
